<template>
  <div class="mobile-header">
    <div class="logo"><img src="@/assets/img/logo.png" height="30" @click="jumpHome" alt=""></div>
    <div class="language">
      <a-dropdown :trigger="['click']">
        <a-icon type="global" />
        <ul slot="overlay">
          <li><img @click="handleLanguage('en-US')" class="text-link" width="30" src="@/assets/img/english.jpg" alt="">
          </li>
          <li><img @click="handleLanguage('zh-CN')" class="text-link" width="30" src="@/assets/img/china.jpg" alt="">
          </li>
        </ul>
      </a-dropdown>
    </div>

    <div class="mobile-menu" @click="showMenu">
      <!-- <a-dropdown :trigger="['click']" class="width-full"> -->
        <a-icon type="menu" />
        <!-- <Navigation></Navigation> -->
      <!-- </a-dropdown> -->
    </div>
    <Navigation ref="navigation"></Navigation>

    <!-- <div class="login" @click="jumpLogin"> -->
      <!-- <a-icon type="login" /> -->
    <!-- </div> -->
  </div>
</template>

<script>
import Navigation from './navigation'
export default {
  components: {
    Navigation
  },
  data () {
    return {

    }
  },
  methods: {
    jumpHome () {
      this.$router.push({
        path: '/'
      })
    },

    showMenu () {
      this.$refs.navigation.open()
    },

    jumpLogin () {
      window.open('http://cloud.jwis.cn/#/login')
    },

    handleLanguage (value) {
      if (value !== localStorage.getItem('jw-locale')) {
        localStorage.setItem('jw-locale', value)
        // this.jumpHome()
        this.handleReload()
      }
    },

    handleReload () {
      window.location.reload()
    }
  }
}

</script>

<style scoped>
  .mobile-header {
    position: relative;
    display: flex;
    align-items: center;
    height: 50px;
    padding: 0 10px;
    /* overflow: hidden; */
  }

  .logo {
    flex: 1;
  }

  .login,
  .language,
  .mobile-menu {
    width: 40px;
    text-align: center;
    font-size: 24px;
  }

</style>
